export default class ItemLocation {

    constructor() {
        this.type = "type";
        this.label = "label";
        this.aisle = "aisle";
        this.bin = "bin";
        this.rack = "rack";
        this.chute = "chute";
        this.floorLocation = "floorLocation";
        this.stationPair = "stationPair";
    }
}



// WEBPACK FOOTER //
// ./src/models/item-location.js